module.exports = __webpack_public_path__ + "static/img/news6_2.d7b7bb6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news6_2.jpg
// module id = pywG
// module chunks = 0